import { useState, useEffect, RefObject } from 'react'

interface UseShopActiveCategoryType {
  activeCardIndex: number | null
}

/** This hook will track the active card index babsed on user scroll position */
const useShopActiveCategory = (categoryRefs: RefObject<HTMLDivElement>[]): UseShopActiveCategoryType => {
  const [activeCardIndex, setActiveCardIndex] = useState<number | null>(null)

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollY = window.scrollY
      const windowHeight = window.innerHeight
      const halfWindowHeight = windowHeight / 2
      let newActiveIndex = null

      categoryRefs.some((ref, index) => {
        if (ref.current) {
          const element = ref.current
          const rect = element.getBoundingClientRect()
          const cardTop = rect.top + scrollY
          const cardBottom = cardTop + rect.height

          if (cardTop < scrollY + halfWindowHeight && cardBottom > scrollY + halfWindowHeight) {
            newActiveIndex = index
            return true
          }
        }
        return false
      })

      setActiveCardIndex(newActiveIndex)
    }

    window.addEventListener('scroll', handleScroll)
    /** Call the initial handleScroll to set the initial active card */
    handleScroll()
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [categoryRefs])

  return { activeCardIndex }
}

export default useShopActiveCategory
